import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./styles.module.scss";
import { faCirclePlay } from "@fortawesome/pro-regular-svg-icons";
import classnames from "utilities/classnames";

type PlayVideoButtonProps = {
  className?: string;
};

export const PlayVideoButton = (props: PlayVideoButtonProps) => {
  const { className } = props;

  return (
    <button className={classnames(styles.root, className)}>
      <FontAwesomeIcon icon={faCirclePlay} size="2x" />
      Play Video
    </button>
  );
};
